import React, { useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import DashboardSidebar from "../../layout/DashboardSidebar";
import { sidebarData } from './EmployeeSidebarSAPL';

const EmployeeDashboardSAPL = () => {

    const [isexpand, setExpanded] = useState(false);
    const [showttext, Setshowtext] = useState(false)
    const navigate = useNavigate();

    const handleopen = () => Setshowtext(true);
    const handleclosetext = () => Setshowtext(false);
    const [show, setShow] = useState(false); //Announcement Notify

    const handleClose = () => setShow(false);

    const location = useLocation();

    const EmployeeDashboardSAPL = location.pathname.includes('/EmployeeDashboardsapl');
    return (
        <>
            <div className="dashboard-main-section">
                <DashboardSidebar sidebarData={sidebarData} isexpand={isexpand} setExpanded={setExpanded} />
                <div className={isexpand ? "dashboard-main-content-sectionn" : "dashboard-main-content-sectionnn"}>

                    <Outlet />
                    {EmployeeDashboardSAPL && <><div
                        style={{
                            position: "fixed",
                            bottom: showttext ? "120px" : "100px", // Adjust position for animation
                            right: "30px",
                            zIndex: 99999,
                            color: "white",
                            backgroundColor: "#2576bc",
                            padding: "8px 12px",
                            borderRadius: "5px",
                            opacity: showttext ? 1 : 0, // Fade in and out
                            transform: `translateY(${showttext ? "0px" : "10px"})`,
                            transition: "opacity 0.3s ease, transform 0.3s ease",
                            pointerEvents: showttext ? "auto" : "none",
                        }}
                    >
                        Raise a ticket
                    </div>
                        <div
                            style={{
                                position: 'fixed',
                                bottom: '30px',
                                right: '30px',
                                zIndex: 99,
                                backgroundColor: '#2576bc',
                                borderRadius: '50%',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={handleopen}
                            onMouseLeave={handleclosetext}
                        >

                            <svg
                                style={{ marginTop: '3px' }}
                                fill="#fcfafa"
                                width="80"
                                height="80"
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.1"
                                viewBox="-5.0 -10.0 110.0 135.0"
                                onClick={() => navigate("/account/myticket")}
                            >
                                <g>
                                    <path d="m80 50c0-9.2031-4.2188-17.895-11.453-23.582-7.2305-5.6914-16.672-7.7461-25.617-5.5781-8.9414 2.168-16.395 8.3203-20.219 16.688-3.8203 8.3711-3.5938 18.031 0.62109 26.211l-3.1641 11.094c-0.41406 1.4141-0.023438 2.9414 1.0195 3.9805 1.0391 1.043 2.5664 1.4336 3.9805 1.0195l11.082-3.1797c9.2969 4.7969 20.422 4.4023 29.359-1.043 8.9336-5.4414 14.387-15.148 14.391-25.609zm-43.566 23.199c-0.15625 0-0.30859 0.023437-0.45703 0.066406l-11.734 3.3672c-0.25 0.074219-0.51563 0.007813-0.69922-0.17578-0.18359-0.18359-0.25-0.45312-0.17578-0.69922l3.3516-11.75c0.12109-0.42187 0.070312-0.875-0.14062-1.2578-4.1328-7.5859-4.3438-16.695-0.56641-24.465 3.7773-7.7656 11.074-13.223 19.594-14.652 8.5156-1.4336 17.199 1.3438 23.305 7.4492 6.1055 6.1094 8.8828 14.789 7.4531 23.309-1.4297 8.5156-6.8906 15.816-14.656 19.59-7.7656 3.7773-16.879 3.5664-24.461-0.56641-0.25-0.14062-0.52734-0.21094-0.8125-0.21484z" />
                                    <path d="m95.922 41.762c-2.6094-14.477-11.887-26.875-25.035-33.461-13.152-6.5859-28.637-6.5859-41.789 0-13.152 6.5859-22.43 18.984-25.035 33.461-2.3555 0.44922-4.0586 2.5078-4.0625 4.9062v13.332c0 2.7617 2.2383 5 5 5h8.332c0.88672 0 1.7344-0.35156 2.3594-0.97656s0.97656-1.4727 0.97656-2.3555v-16.668c-0.007813-1.4648-0.97266-2.7539-2.3789-3.1758 2.4727-10.871 9.7656-20.023 19.809-24.863 10.043-4.8398 21.746-4.8398 31.789 0 10.043 4.8398 17.336 13.992 19.805 24.863-1.3945 0.42578-2.3516 1.7148-2.3594 3.1758v16.668c0 0.88281 0.35156 1.7305 0.97656 2.3555s1.4727 0.97656 2.3594 0.97656h3.25-0.003907c-0.42578 6.3203-3.2305 12.246-7.8555 16.578s-10.723 6.7461-17.059 6.7539h-3.5703c-0.75781-2.9336-3.3984-4.9883-6.4297-5h-10c-3.6836 0-6.668 2.9844-6.668 6.668s2.9844 6.668 6.668 6.668h10c3.0312-0.011719 5.6719-2.0664 6.4297-5h3.5703c7.2188-0.011719 14.16-2.7773 19.41-7.7344 5.25-4.957 8.4102-11.727 8.8398-18.934h1.75c2.7617 0 5-2.2383 5-5v-13.332c-0.003906-2.4062-1.7188-4.4648-4.0781-4.9062zm-40.922 51.57h-10c-1.8398 0-3.332-1.4922-3.332-3.332s1.4922-3.332 3.332-3.332h10c1.8398 0 3.332 1.4922 3.332 3.332s-1.4922 3.332-3.332 3.332z" />
                                </g>
                            </svg>
                        </div></>}
                    <Modal show={show} onHide={handleClose} dialogClassName="model-annoucee">
                        <Modal.Header closeButton>

                        </Modal.Header>
                        <Modal.Body >
                            <img src="https://civilmantra.s3.ap-south-1.amazonaws.com/Ashish+Dhaiya.png" alt="demo" className="model-annoucee-pic" />

                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default EmployeeDashboardSAPL